export default "__VITE_PUBLIC_ASSET__50fbe6cc__"